import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Link } from '@uhg-abyss/web/ui/Link';
import { ProcessingStatItem } from '../ProcessingStatsItem';

export const ErrorTransCount = ({
  procStatsList,
  onChildValueChange,
  service,
}) => {
  const handlSubReslnChanges = (e) => {
    e.preventDefault();

    onChildValueChange('EE');
  };
  const handleEligibilityAnalystChanges = (e) => {
    e.preventDefault();

    onChildValueChange('IE');
  };

  return service === 'gps' ? (
    <ProcessingStatItem title="Error Transaction Count">
      <Layout.Group grow>
        <Table.Container title="">
          <Table.TableBody>
            <Table.Row>
              <Table.Cell>
                <b>Adds Requiring Customer Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.addsRequiringCustomerResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Terms Submitted Requiring Customer Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.termsSubmittedRequiringCustomerResolution
                }
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>
                <b>Changes Requiring Customer Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.changesRequiringCustomerResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Rejected Transactions Requiring Customer Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.rejectedTransactionsRequiringCustomerResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <Link onClick={handlSubReslnChanges} href="#">
                  Total Customer Resolution Transactions
                </Link>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.totalCustomerResolutionTransactions
                }
              </Table.Cell>
            </Table.Row>
          </Table.TableBody>
        </Table.Container>
        <Table.Container title="">
          <Table.TableBody>
            <Table.Row>
              <Table.Cell>
                <b>Adds Requiring Eligibility Analyst Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.addsRequiringEligibilityAnalystResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Terms Submitted Requiring Eligibility Analyst Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.termsSubmittedRequiringEligibilityAnalystResolution
                }
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>
                <b>Changes Requiring Eligibility Analyst Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.changesRequiringEligibilityAnalystResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>
                  Rejected Transactions Requiring Eligibility Analyst Resolution
                </b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.rejectedTransactionsRequiringEligibilityAnalystResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <Link onClick={handleEligibilityAnalystChanges} href="#">
                  Total Eligibility Analyst Resolution Transactions
                </Link>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.totalEligibilityAnalystResolutionTransactions
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Transactions requiring Both Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.transactionsRequiringBothResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Total Transactions with Errors</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.totalTransactionsWithErrors
                }
              </Table.Cell>
            </Table.Row>
          </Table.TableBody>
        </Table.Container>
      </Layout.Group>
    </ProcessingStatItem>
  ) : (
    <ProcessingStatItem title="Error Transaction Count">
      <Layout.Group grow>
        <Table.Container title="">
          <Table.TableBody>
            <Table.Row>
              <Table.Cell>
                <b>Adds Requiring Customer Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.addsRequiringCustomerResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Terms Submitted Requiring Customer Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.termsSubmittedRequiringCustomerResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Auto-Cancels Requiring Customer Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.autoCancelsRequiringCustomerResolution
                }
              </Table.Cell>
            </Table.Row>

            <Table.Row>
              <Table.Cell>
                <b>Terms Requiring Customer Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.termsRequiringCustomerResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Changes Requiring Customer Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.changesRequiringCustomerResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Rejected Transactions Requiring Customer Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.rejectedTransactionsRequiringCustomerResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <Link onClick={handlSubReslnChanges} href="#">
                  Total Customer Resolution Transactions
                </Link>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.totalCustomerResolutionTransactions
                }
              </Table.Cell>
            </Table.Row>
          </Table.TableBody>
        </Table.Container>
        <Table.Container title="">
          <Table.TableBody>
            <Table.Row>
              <Table.Cell>
                <b>Adds Requiring Eligibility Analyst Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.addsRequiringEligibilityAnalystResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Terms Submitted Requiring Eligibility Analyst Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.termsSubmittedRequiringEligibilityAnalystResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Auto-Cancels Requiring Eligibility Analyst Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.autoCancelsRequiringEligibilityAnalystResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Terms Requiring Eligibility Analyst Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.termsRequiringEligibilityAnalystResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Changes Requiring Eligibility Analyst Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.changesRequiringEligibilityAnalystResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>
                  Rejected Transactions Requiring Eligibility Analyst Resolution
                </b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.rejectedTransactionsRequiringEligibilityAnalystResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <Link onClick={handleEligibilityAnalystChanges} href="#">
                  Total Eligibility Analyst Resolution Transactions
                </Link>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.totalEligibilityAnalystResolutionTransactions
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Transactions requiring Both Resolution</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.transactionsRequiringBothResolution
                }
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>
                <b>Total Transactions with Errors</b>
              </Table.Cell>
              <Table.Cell>
                {
                  procStatsList?.errorTransactionCount
                    ?.totalTransactionsWithErrors
                }
              </Table.Cell>
            </Table.Row>
          </Table.TableBody>
        </Table.Container>
      </Layout.Group>
    </ProcessingStatItem>
  );
};
